import api, { formDataInstance } from "./baseRequest";

export const productsService = {
  getAllProducts: (pageOptions = {}) => {
    const params = new URLSearchParams();
    if (pageOptions.page) params.append("page", pageOptions.page);
    if (pageOptions.limit) params.append("limit", pageOptions.limit);
    if (pageOptions.sortBy) params.append("sortBy", pageOptions.sortBy);
    if (pageOptions.sortOrder)
      params.append("sortOrder", pageOptions.sortOrder);

    return api.get(`/admin/products?${params.toString()}`);
  },

  getAllProductsWithoutPagination: () => {
    return api.get("/admin/products/all");
  },

  getProductById: (id) => {
    return api.get(`/admin/products/${id}`);
  },

  createProduct: (productData) => {
    const formData = new FormData();
    formData.append("title", productData.title);
    formData.append("description", productData.description);
    formData.append("price", productData.price);
    if (productData.image) {
      formData.append("image", productData.image);
    }
    if (productData.isMenuSliderItem !== undefined) {
      formData.append("isMenuSliderItem", String(productData.isMenuSliderItem));
    }
    if (productData.categoryId) {
      formData.append("categoryId", productData.categoryId);
    }
    if (productData.subcategoryId) {
      formData.append("subcategoryId", productData.subcategoryId);
    }

    return formDataInstance.post("/admin/products", formData);
  },

  updateProduct: (id, productData) => {
    const formData = new FormData();
    formData.append("title", productData.title);
    formData.append("description", productData.description);
    formData.append("price", productData.price);
    if (productData.image) {
      formData.append("image", productData.image);
    }
    if (productData.isMenuSliderItem !== undefined) {
      formData.append("isMenuSliderItem", String(productData.isMenuSliderItem));
    }
    if (productData.categoryId) {
      formData.append("categoryId", productData.categoryId);
    }
    if (productData.subcategoryId) {
      formData.append("subcategoryId", productData.subcategoryId);
    }

    return formDataInstance.put(`/admin/products/${id}`, formData);
  },

  deleteProduct: (id) => {
    return api.delete(`/admin/products/${id}`);
  },

  reorderProducts: (productIds) => {
    return api.patch("/admin/products/reorder", { productIds });
  },

  updateProductActive: (id, { active }) => {
    return api.patch(`/admin/products/${id}/active`, { active });
  },

  saveMenuSliderItems: (products) => {
    return api.put("/admin/products/menu-slider", { products });
  },

  reorderMenuSlider: ({ id, newOrder }) => {
    return api.patch("/admin/products/menu-slider/reorder", { id, newOrder });
  },

  updateCategoryItems: (data) =>
    api.patch("/admin/products/bulk-assign-category", data),
};
